"use client"

import React from 'react'

export type UseThemeProps = {
  themes: string[]
  setTheme: (t: string) => void
  theme: string
  resolvedTheme: string
}

export function useTheme(): UseThemeProps {
  return {
    themes: ['light'],
    setTheme: () => {},
    theme: 'light',
    resolvedTheme: 'light',
  }
}

export function ThemeProvider({ children }: React.PropsWithChildren) {
  return <>{children}</>
}

export default ThemeProvider
